<template>
  <div class="downloads">
    <app-spinner v-if="!is_loaded" />
    <div v-else>
      <template v-if="show_climbing_block">
        <app-cells>
          <h2 class="title">Climbing team</h2>
        </app-cells>
        <div class="downloads__item" :class="{'downloads__item--loading': downloads.list_of_clients.loading}">
          <div class="downloads__left">
            <img :src="require(`@/assets/img/downloads-${downloads.list_of_clients.format}.svg`)" alt="Download">
            <div class="downloads__info">
              <button @click="onAction(downloads.list_of_clients)" class="downloads__name">{{ downloads.list_of_clients.name }}</button>
              <span class="downloads__qty">Qty: {{ downloads.list_of_clients.qty }}</span>
            </div>
          </div>
          <div class="downloads__right">
            <div class="downloads__values">
              <span class="downloads__key">Printed:</span>
              <app-switcher
                v-model="downloads.list_of_clients.list_of_clients_printed"
                @change="onChangePrinted({list_of_clients_printed: downloads.list_of_clients.list_of_clients_printed})"
              />
            </div>
            <template v-if="downloads.list_of_clients.list_of_clients_printed">
              <div class="downloads__values">
                <span class="downloads__key">Printed at:</span>
                <span class="downloads__value downloads__width">{{ dateTimeFormat(downloads.list_of_clients.list_of_clients_printed_at) }}</span>
              </div>
              <div class="downloads__values">
                <span class="downloads__key">Printed by:</span>
                <div class="downloads__person downloads__width">
                  <div class="downloads__photo">
                    <img :src="getUserAvatar(downloads.list_of_clients.list_of_clients_printed_by?.crop.crop_url)" alt="Person">
                  </div>
                  <span class="downloads__value">{{ downloads.list_of_clients.list_of_clients_printed_by?.full_name || '-' }}</span>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="downloads__item" :class="{'downloads__item--loading': downloads.itinerary.loading}">
          <div class="downloads__left">
            <img :src="require(`@/assets/img/downloads-${downloads.itinerary.format}.svg`)" alt="Download">
            <div class="downloads__info">
              <button @click="onAction(downloads.itinerary)" class="downloads__name">{{ downloads.itinerary.name }}</button>
              <span class="downloads__qty">Qty: {{ downloads.itinerary.qty }}</span>
            </div>
          </div>
          <div class="downloads__right">
            <div class="downloads__values">
              <span class="downloads__key">Printed:</span>
              <app-switcher
                v-model="downloads.itinerary.itinerary_printed"
                @change="onChangePrinted({itinerary_printed: downloads.itinerary.itinerary_printed})"
              />
            </div>
            <template v-if="downloads.itinerary.itinerary_printed">
              <div class="downloads__values">
                <span class="downloads__key">Printed at:</span>
                <span class="downloads__value downloads__width">{{ dateTimeFormat(downloads.itinerary.itinerary_printed_at) }}</span>
              </div>
              <div class="downloads__values">
                <span class="downloads__key">Printed by:</span>
                <div class="downloads__person downloads__width">
                  <div class="downloads__photo">
                    <img :src="getUserAvatar(downloads.itinerary.itinerary_printed_by?.crop.crop_url)" alt="Person">
                  </div>
                  <span class="downloads__value">{{ downloads.itinerary.itinerary_printed_by?.full_name || '-' }}</span>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="downloads__item" :class="{'downloads__item--loading': downloads.medical_check_up.loading}">
          <div class="downloads__left">
            <img :src="require(`@/assets/img/downloads-${downloads.medical_check_up.format}.svg`)" alt="Download">
            <div class="downloads__info">
              <button @click="onAction(downloads.medical_check_up)" class="downloads__name">{{ downloads.medical_check_up.name }}</button>
              <span class="downloads__qty">Qty: {{ downloads.medical_check_up.qty }}</span>
            </div>
          </div>
          <div class="downloads__right">
            <div class="downloads__values">
              <span class="downloads__key">Printed:</span>
              <app-switcher
                v-model="downloads.medical_check_up.medical_check_up_printed"
                @change="onChangePrinted({medical_check_up_printed: downloads.medical_check_up.medical_check_up_printed})"
              />
            </div>
            <template v-if="downloads.medical_check_up.medical_check_up_printed">
              <div class="downloads__values">
                <span class="downloads__key">Printed at:</span>
                <span class="downloads__value downloads__width">{{ dateTimeFormat(downloads.medical_check_up.medical_check_up_printed_at) }}</span>
              </div>
              <div class="downloads__values">
                <span class="downloads__key">Printed by:</span>
                <div class="downloads__person downloads__width">
                  <div class="downloads__photo">
                    <img :src="getUserAvatar(downloads.medical_check_up.medical_check_up_printed_by?.crop.crop_url)" alt="Person">
                  </div>
                  <span class="downloads__value">{{ downloads.medical_check_up.medical_check_up_printed_by?.full_name || '-' }}</span>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="downloads__item" :class="{'downloads__item--loading': downloads.voucher.loading}">
          <div class="downloads__left">
            <img :src="require(`@/assets/img/downloads-${downloads.voucher.format}.svg`)" alt="Download">
            <div class="downloads__info">
              <button @click="onAction(downloads.voucher)" class="downloads__name">{{ downloads.voucher.name }}</button>
              <span class="downloads__qty">Qty: {{ downloads.voucher.qty }}</span>
            </div>
          </div>
          <div class="downloads__right">
            <div class="downloads__values">
              <span class="downloads__key">Printed:</span>
              <app-switcher
                v-model="downloads.voucher.voucher_printed"
                @change="onChangePrinted({voucher_printed: downloads.voucher.voucher_printed})"
              />
            </div>
            <template v-if="downloads.voucher.voucher_printed">
              <div class="downloads__values">
                <span class="downloads__key">Printed at:</span>
                <span class="downloads__value downloads__width">{{ dateTimeFormat(downloads.voucher.voucher_printed_at) }}</span>
              </div>
              <div class="downloads__values">
                <span class="downloads__key">Printed by:</span>
                <div class="downloads__person downloads__width">
                  <div class="downloads__photo">
                    <img :src="getUserAvatar(downloads.voucher.voucher_printed_by?.crop.crop_url)" alt="Person">
                  </div>
                  <span class="downloads__value">{{ downloads.voucher.voucher_printed_by?.full_name || '-' }}</span>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="downloads__item" :class="{'downloads__item--loading': downloads.visitor_registration.loading}">
          <div class="downloads__left">
            <img :src="require(`@/assets/img/downloads-${downloads.visitor_registration.format}.svg`)" alt="Download">
            <div class="downloads__info">
              <button @click="onAction(downloads.visitor_registration)" class="downloads__name">{{ downloads.visitor_registration.name }}</button>
              <span class="downloads__qty">Qty: {{ downloads.visitor_registration.qty }}</span>
            </div>
          </div>
          <div class="downloads__right">
            <div class="downloads__values">
              <span class="downloads__key">Printed:</span>
              <app-switcher
                v-model="downloads.visitor_registration.visitor_registration_printed"
                @change="onChangePrinted({visitor_registration_printed: downloads.visitor_registration.visitor_registration_printed})"
              />
            </div>
            <template v-if="downloads.visitor_registration.visitor_registration_printed">
              <div class="downloads__values">
                <span class="downloads__key">Printed at:</span>
                <span class="downloads__value downloads__width">{{ dateTimeFormat(downloads.visitor_registration.visitor_registration_printed_at) }}</span>
              </div>
              <div class="downloads__values">
                <span class="downloads__key">Printed by:</span>
                <div class="downloads__person downloads__width">
                  <div class="downloads__photo">
                    <img :src="getUserAvatar(downloads.visitor_registration.visitor_registration_printed_by?.crop.crop_url)" alt="Person">
                  </div>
                  <span class="downloads__value">{{ downloads.visitor_registration.visitor_registration_printed_by?.full_name || '-' }}</span>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="downloads__item" :class="{'downloads__item--loading': downloads.list_for_reception.loading}">
          <div class="downloads__left">
            <img :src="require(`@/assets/img/downloads-${downloads.list_for_reception.format}.svg`)" alt="Download">
            <div class="downloads__info">
              <button @click="onAction(downloads.list_for_reception)" class="downloads__name">{{ downloads.list_for_reception.name }}</button>
              <span class="downloads__qty">Qty: {{ downloads.list_for_reception.qty }}</span>
            </div>
          </div>
          <div class="downloads__right">
            <div class="downloads__values">
              <span class="downloads__key">Printed:</span>
              <app-switcher
                v-model="downloads.list_for_reception.list_for_reception_printed"
                @change="onChangePrinted({list_for_reception_printed: downloads.list_for_reception.list_for_reception_printed})"
              />
            </div>
            <template v-if="downloads.list_for_reception.list_for_reception_printed">
              <div class="downloads__values">
                <span class="downloads__key">Printed at:</span>
                <span class="downloads__value downloads__width">{{ dateTimeFormat(downloads.list_for_reception.list_for_reception_printed_at) }}</span>
              </div>
              <div class="downloads__values">
                <span class="downloads__key">Printed by:</span>
                <div class="downloads__person downloads__width">
                  <div class="downloads__photo">
                    <img :src="getUserAvatar(downloads.list_for_reception.list_for_reception_printed_by?.crop.crop_url)" alt="Person">
                  </div>
                  <span class="downloads__value">{{ downloads.list_for_reception.list_for_reception_printed_by?.full_name || '-' }}</span>
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>
      <template v-if="show_operation_block">
        <app-cells>
          <h2 class="title">Operation team</h2>
        </app-cells>
        <div class="downloads__item" :class="{'downloads__item--loading': downloads.preparation_list.loading}">
          <div class="downloads__left">
            <img :src="require(`@/assets/img/downloads-${downloads.preparation_list.format}.svg`)" alt="Download">
            <div class="downloads__info">
              <button @click="onAction(downloads.preparation_list)" class="downloads__name">{{ downloads.preparation_list.name }}</button>
              <span class="downloads__qty">Qty: {{ downloads.preparation_list.qty }}</span>
            </div>
          </div>
          <div class="downloads__right">
            <div class="downloads__values">
              <span class="downloads__key">Printed:</span>
              <app-switcher
                v-model="downloads.preparation_list.preparation_list_printed"
                @change="onChangePrinted({preparation_list_printed: downloads.preparation_list.preparation_list_printed})"
              />
            </div>
            <template v-if="downloads.preparation_list.preparation_list_printed">
              <div class="downloads__values">
                <span class="downloads__key">Printed at:</span>
                <span class="downloads__value downloads__width">{{ dateTimeFormat(downloads.preparation_list.preparation_list_printed_at) }}</span>
              </div>
              <div class="downloads__values">
                <span class="downloads__key">Printed by:</span>
                <div class="downloads__person downloads__width">
                  <div class="downloads__photo">
                    <img :src="getUserAvatar(downloads.preparation_list.preparation_list_printed_by?.crop.crop_url)" alt="Person">
                  </div>
                  <span class="downloads__value">{{ downloads.preparation_list.preparation_list_printed_by?.full_name || '-' }}</span>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="downloads__item" :class="{'downloads__item--loading': downloads.equipment_checklist.loading}">
          <div class="downloads__left">
            <img :src="require(`@/assets/img/downloads-${downloads.equipment_checklist.format}.svg`)" alt="Download">
            <div class="downloads__info">
              <button @click="onAction(downloads.equipment_checklist)" class="downloads__name">{{ downloads.equipment_checklist.name }}</button>
              <span class="downloads__qty">Qty: {{ downloads.equipment_checklist.qty }}</span>
            </div>
          </div>
          <div class="downloads__right">
            <div class="downloads__values">
              <span class="downloads__key">Printed:</span>
              <app-switcher
                v-model="downloads.equipment_checklist.equipment_checklist_printed"
                @change="onChangePrinted({equipment_checklist_printed: downloads.equipment_checklist.equipment_checklist_printed})"
              />
            </div>
            <template v-if="downloads.equipment_checklist.equipment_checklist_printed">
              <div class="downloads__values">
                <span class="downloads__key">Printed at:</span>
                <span class="downloads__value downloads__width">{{ dateTimeFormat(downloads.equipment_checklist.equipment_checklist_printed_at) }}</span>
              </div>
              <div class="downloads__values">
                <span class="downloads__key">Printed by:</span>
                <div class="downloads__person downloads__width">
                  <div class="downloads__photo">
                    <img :src="getUserAvatar(downloads.equipment_checklist.equipment_checklist_printed_by?.crop.crop_url)" alt="Person">
                  </div>
                  <span class="downloads__value">{{ downloads.equipment_checklist.equipment_checklist_printed_by?.full_name || '-' }}</span>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="downloads__item" :class="{'downloads__item--loading': downloads.duffle_bag_tags.loading}">
          <div class="downloads__left">
            <img :src="require(`@/assets/img/downloads-${downloads.duffle_bag_tags.format}.svg`)" alt="Download">
            <div class="downloads__info">
              <button @click="onAction(downloads.duffle_bag_tags)" class="downloads__name">{{ downloads.duffle_bag_tags.name }}</button>
              <span class="downloads__qty">Qty: {{ downloads.duffle_bag_tags.qty }}</span>
            </div>
          </div>
          <div class="downloads__right">
            <div class="downloads__values">
              <span class="downloads__key">Printed:</span>
              <app-switcher
                v-model="downloads.duffle_bag_tags.duffle_bag_tags_printed"
                @change="onChangePrinted({duffle_bag_tags_printed: downloads.duffle_bag_tags.duffle_bag_tags_printed})"
              />
            </div>
            <template v-if="downloads.duffle_bag_tags.duffle_bag_tags_printed">
              <div class="downloads__values">
                <span class="downloads__key">Printed at:</span>
                <span class="downloads__value downloads__width">{{ dateTimeFormat(downloads.duffle_bag_tags.duffle_bag_tags_printed_at) }}</span>
              </div>
              <div class="downloads__values">
                <span class="downloads__key">Printed by:</span>
                <div class="downloads__person downloads__width">
                  <div class="downloads__photo">
                    <img :src="getUserAvatar(downloads.duffle_bag_tags.duffle_bag_tags_printed_by?.crop.crop_url)" alt="Person">
                  </div>
                  <span class="downloads__value">{{ downloads.duffle_bag_tags.duffle_bag_tags_printed_by?.full_name || '-' }}</span>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="downloads__item" :class="{'downloads__item--loading': downloads.luggage_tags.loading}">
          <div class="downloads__left">
            <img :src="require(`@/assets/img/downloads-${downloads.luggage_tags.format}.svg`)" alt="Download">
            <div class="downloads__info">
              <button @click="onAction(downloads.luggage_tags)" class="downloads__name">{{ downloads.luggage_tags.name }}</button>
              <span class="downloads__qty">Qty: {{ downloads.luggage_tags.qty }}</span>
            </div>
          </div>
          <div class="downloads__right">
            <div class="downloads__values">
              <span class="downloads__key">Printed:</span>
              <app-switcher
                v-model="downloads.luggage_tags.luggage_tags_printed"
                @change="onChangePrinted({luggage_tags_printed: downloads.luggage_tags.luggage_tags_printed})"
              />
            </div>
            <template v-if="downloads.luggage_tags.luggage_tags_printed">
              <div class="downloads__values">
                <span class="downloads__key">Printed at:</span>
                <span class="downloads__value downloads__width">{{ dateTimeFormat(downloads.luggage_tags.luggage_tags_printed_at) }}</span>
              </div>
              <div class="downloads__values">
                <span class="downloads__key">Printed by:</span>
                <div class="downloads__person downloads__width">
                  <div class="downloads__photo">
                    <img :src="getUserAvatar(downloads.luggage_tags.luggage_tags_printed_by?.crop.crop_url)" alt="Person">
                  </div>
                  <span class="downloads__value">{{ downloads.luggage_tags.luggage_tags_printed_by?.full_name || '-' }}</span>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="downloads__item" :class="{'downloads__item--loading': downloads.departure_form.loading}">
          <div class="downloads__left">
            <img :src="require(`@/assets/img/downloads-${downloads.departure_form.format}.svg`)" alt="Download">
            <div class="downloads__info">
              <button @click="onAction(downloads.departure_form)" class="downloads__name">{{ downloads.departure_form.name }}</button>
              <span class="downloads__qty">Qty: {{ downloads.departure_form.qty }}</span>
            </div>
          </div>
          <div class="downloads__right">
            <div class="downloads__values">
              <span class="downloads__key">Printed:</span>
              <app-switcher
                v-model="downloads.departure_form.departure_form_printed"
                @change="onChangePrinted({departure_form_printed: downloads.departure_form.departure_form_printed})"
              />
            </div>
            <template v-if="downloads.departure_form.departure_form_printed">
              <div class="downloads__values">
                <span class="downloads__key">Printed at:</span>
                <span class="downloads__value downloads__width">{{ dateTimeFormat(downloads.departure_form.departure_form_printed_at) }}</span>
              </div>
              <div class="downloads__values">
                <span class="downloads__key">Printed by:</span>
                <div class="downloads__person downloads__width">
                  <div class="downloads__photo">
                    <img :src="getUserAvatar(downloads.departure_form.departure_form_printed_by?.crop.crop_url)" alt="Person">
                  </div>
                  <span class="downloads__value">{{ downloads.departure_form.departure_form_printed_by?.full_name || '-' }}</span>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="downloads__item" :class="{'downloads__item--loading': downloads.personal_belongings.loading}">
          <div class="downloads__left">
            <img :src="require(`@/assets/img/downloads-${downloads.personal_belongings.format}.svg`)" alt="Download">
            <div class="downloads__info">
              <button @click="onAction(downloads.personal_belongings)" class="downloads__name">{{ downloads.personal_belongings.name }}</button>
              <span class="downloads__qty">Qty: {{ downloads.personal_belongings.qty }}</span>
            </div>
          </div>
          <div class="downloads__right">
            <div class="downloads__values">
              <span class="downloads__key">Printed:</span>
              <app-switcher
                v-model="downloads.personal_belongings.personal_belongings_printed"
                @change="onChangePrinted({personal_belongings_printed: downloads.personal_belongings.personal_belongings_printed})"
              />
            </div>
            <template v-if="downloads.personal_belongings.personal_belongings_printed">
              <div class="downloads__values">
                <span class="downloads__key">Printed at:</span>
                <span class="downloads__value downloads__width">{{ dateTimeFormat(downloads.personal_belongings.personal_belongings_printed_at) }}</span>
              </div>
              <div class="downloads__values">
                <span class="downloads__key">Printed by:</span>
                <div class="downloads__person downloads__width">
                  <div class="downloads__photo">
                    <img :src="getUserAvatar(downloads.personal_belongings.personal_belongings_printed_by?.crop.crop_url)" alt="Person">
                  </div>
                  <span class="downloads__value">{{ downloads.personal_belongings.personal_belongings_printed_by?.full_name || '-' }}</span>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="downloads__item" :class="{'downloads__item--loading': downloads.gps.loading}">
          <div class="downloads__left">
            <img :src="require(`@/assets/img/downloads-${downloads.gps.format}.svg`)" alt="Download">
            <div class="downloads__info">
              <button @click="onAction(downloads.gps)" class="downloads__name">{{ downloads.gps.name }}</button>
              <span class="downloads__qty">Qty: {{ downloads.gps.qty }}</span>
            </div>
          </div>
          <div class="downloads__right">
            <div class="downloads__values">
              <span class="downloads__key">Printed:</span>
              <app-switcher
                v-model="downloads.gps.gps_printed"
                @change="onChangePrinted({gps_printed: downloads.gps.gps_printed})"
              />
            </div>
            <template v-if="downloads.gps.gps_printed">
              <div class="downloads__values">
                <span class="downloads__key">Printed at:</span>
                <span class="downloads__value downloads__width">{{ dateTimeFormat(downloads.gps.gps_printed_at) }}</span>
              </div>
              <div class="downloads__values">
                <span class="downloads__key">Printed by:</span>
                <div class="downloads__person downloads__width">
                  <div class="downloads__photo">
                    <img :src="getUserAvatar(downloads.gps.gps_printed_by?.crop.crop_url)" alt="Person">
                  </div>
                  <span class="downloads__value">{{ downloads.gps.gps_printed_by?.full_name || '-' }}</span>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="downloads__item" :class="{'downloads__item--loading': downloads.itinerary.loading}">
          <div class="downloads__left">
            <img :src="require(`@/assets/img/downloads-${downloads.itinerary.format}.svg`)" alt="Download">
            <div class="downloads__info">
              <button @click="onAction(downloads.itinerary)" class="downloads__name">{{ downloads.itinerary.name }}</button>
              <span class="downloads__qty">Qty: {{ downloads.itinerary.qty }}</span>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {
  getClimbingGroupLuggageTags,
  getClimbingGroupDepartureForm,
  getClimbingGroupPersonalBelongings,
  getClimbingGroupArrivalForm,
  getClimbingGroupDocs,
  getClimbingGroupChecklistsExport,
  getClimbingGroupDuffleBagTags,
  getClimbingGroupListOfReception,
  getClimbingGroupGPS,
  getClimbingGroupVisitorRegistration,
  getClimbingGroupVoucher,
  getClimbingGroupPrintInfo,
  patchClimbingGroupPrintInfo,
  getClimbingGroupListOfClients,
  getClimbingGroupItinerary,
  getClimbingGroupMedicalCheckUp,
  getClimbingGroupPreparationList
} from '@/http'
import {format, parse, parseISO} from 'date-fns'

export default {
  name: 'ClimbingGroupsDetailDownloads',
  props: {
    groupDetail: {
      type: Object
    }
  },
  data() {
    return {
      is_loaded: false,
      checklist_loading: false,
      downloads: {
        list_of_clients: {
          action: getClimbingGroupListOfClients,
          name: 'List of clients',
          format: 'pdf',
          qty: 1,
          loading: false,
          list_of_clients_printed: false,
          list_of_clients_printed_at: null,
          list_of_clients_printed_by: null,
        },
        itinerary: {
          action: getClimbingGroupItinerary,
          name: 'Itinerary',
          format: 'pdf',
          qty: 1,
          loading: false,
          itinerary_printed: false,
          itinerary_printed_at: null,
          itinerary_printed_by: null,
        },
        medical_check_up: {
          action: getClimbingGroupMedicalCheckUp,
          name: 'Medical Check-Up',
          format: 'pdf',
          qty: 1,
          loading: false,
          medical_check_up_printed: false,
          medical_check_up_printed_at: null,
          medical_check_up_printed_by: null,
        },
        voucher: {
          action: getClimbingGroupVoucher,
          name: 'Voucher',
          format: 'pdf',
          qty: 1,
          loading: false,
          voucher_printed: false,
          voucher_printed_at: null,
          voucher_printed_by: null,
        },
        visitor_registration: {
          action: getClimbingGroupVisitorRegistration,
          name: 'Visitor registration',
          format: 'pdf',
          qty: 1,
          loading: false,
          visitor_registration_printed: false,
          visitor_registration_printed_at: null,
          visitor_registration_printed_by: null,
        },
        list_for_reception: {
          action: getClimbingGroupListOfReception,
          name: 'List for reception',
          format: 'pdf',
          qty: 1,
          loading: false,
          list_for_reception_printed: false,
          list_for_reception_printed_at: null,
          list_for_reception_printed_by: null,
        },
        gps: {
          action: getClimbingGroupGPS,
          name: 'GPS',
          format: 'pdf',
          qty: 1,
          loading: false,
          gps_printed: false,
          gps_printed_at: null,
          gps_printed_by: null,
        },
        preparation_list:  {
          action: getClimbingGroupPreparationList,
          name: 'Preparation list',
          format: 'pdf',
          qty: 1,
          loading: false,
          preparation_list_printed: false,
          preparation_list_printed_at: null,
          preparation_list_printed_by: null,
        },
        equipment_checklist:  {
          action: getClimbingGroupChecklistsExport,
          name: 'Equipment checklist',
          format: 'pdf',
          qty: 1,
          loading: false,
          equipment_checklist_printed: false,
          equipment_checklist_printed_at: null,
          equipment_checklist_printed_by: null,
        },
        duffle_bag_tags: {
          action: getClimbingGroupDuffleBagTags,
          name: 'Duffle bag tags',
          format: 'pdf',
          qty: 1,
          loading: false,
          duffle_bag_tags_printed: false,
          duffle_bag_tags_printed_at: null,
          duffle_bag_tags_printed_by: null,
        },
        luggage_tags: {
          action: getClimbingGroupLuggageTags,
          name: 'Luggage tags',
          format: 'pdf',
          qty: 3,
          loading: false,
          luggage_tags_printed: false,
          luggage_tags_printed_at: null,
          luggage_tags_printed_by: null,
        },
        departure_form: {
          action: getClimbingGroupDepartureForm,
          name: 'Departure form',
          format: 'pdf',
          qty: 1,
          loading: false,
          departure_form_printed: false,
          departure_form_printed_at: null,
          departure_form_printed_by: null,
        },
        personal_belongings: {
          action: getClimbingGroupPersonalBelongings,
          name: 'Register of Personal Belongings',
          format: 'pdf',
          qty: 1,
          loading: false,
          personal_belongings_printed: false,
          personal_belongings_printed_at: null,
          personal_belongings_printed_by: null,
        },
      },
    }
  },
  computed: {
    show_climbing_block() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager') ||
        this.$store.state.userGroups.map(item => item.code).includes('climbing_manager') ||
        this.$store.state.userGroups.map(item => item.code).includes('climbing_supervisor') ||
        this.$store.state.userGroups.map(item => item.code).includes('climbing_assistant')
    },
    show_operation_block() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager') ||
        this.$store.state.userGroups.map(item => item.code).includes('operations_manager') ||
        this.$store.state.userGroups.map(item => item.code).includes('operations_supervisor')
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    onChangePrinted(data) {
      patchClimbingGroupPrintInfo(this.groupDetail.id, data)
        .then(response => {
          this.loopForFields(response)
        })
    },
    fetchData() {
      getClimbingGroupPrintInfo(this.groupDetail.id)
        .then(response => {
          this.loopForFields(response)
          this.is_loaded = true
        })
    },
    loopForFields(response) {
      for (const downloadsKey in this.downloads) {
        this.downloads[downloadsKey][`${downloadsKey}_printed`] = response.data[`${downloadsKey}_printed`]
        this.downloads[downloadsKey][`${downloadsKey}_printed_at`] = response.data[`${downloadsKey}_printed_at`]
        this.downloads[downloadsKey][`${downloadsKey}_printed_by`] = response.data[`${downloadsKey}_printed_by`]
      }
    },
    onAction(link) {
      link.loading = true
      link.action(this.groupDetail.id)
        .then(response => {
          link.loading = false
          window.open(response.data)
        })
        .catch(() => {
          link.loading = false
        })
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : '-'
    },
    dateTimeFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : '-'
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
  }
}
</script>

<style lang="sass" scoped>
.downloads
  position: relative
  min-height: 500px
</style>
